import "./ProposalHeroCircleSquare.scss";
import { classNames } from "primereact/utils";
import { useEffect, useState } from "react";
import { borderRadius, handleHeroMediaType, handleTypeSpecificClick, proposalHeroColorTypes, proposalHeroTypes, typeIconMap } from "./ProposalHeroConfig";
import { playInitialTweens, proposalHeroTimeline, proposalHoverTimeline, reverseProposalHeroTimeline } from "./ProposalHeroTweens";


function ProposalHeroCircleSquare({ id, currentCard, setCurrentCard, prevCard, setPrevCard, toggleModal, isHover, setIsHover, proposalData, containerType, isLast, setIsError }) {
  const { color, collateralData: { headingText, backgroundImage }, data: { type, pdf: pdfFile, link, video, images } } = proposalData;  
  useEffect(() => {
    if (id === currentCard) {
      proposalHeroTimeline(id).play();
    }
    else {
      reverseProposalHeroTimeline(prevCard).play();
    }
  }, [currentCard])

  useEffect(() => {
    playInitialTweens(containerType, currentCard, id);
    const heroError = handleHeroMediaType(type, pdfFile, link, video, images, setIsError);
    setIsError(prev => [...prev, heroError]);
  }, [])
  function handleMouseEnter() {
    setIsHover(true)
    setPrevCard(currentCard)
    setCurrentCard(id);
    proposalHoverTimeline(id).play();
  }
  function handleMouseLeave() {
    proposalHoverTimeline(id).reverse(0);
    setIsHover(false)
  }


  function handleClick() {
    handleTypeSpecificClick({ type, pdfFile, link, setShowProposalModal: () => toggleModal({ images, video, type }) });
  }
  return (
    <div className={classNames("ProposalHeroCircleSquareContainer relative flex align-items-center justify-content-center cursor-pointer", `ProposalHeroCircleSquareContainer-${id}`)} >
      <div className={classNames("MovingGradient absolute z-0 top-0 left-0", containerType, borderRadius[containerType], { "isLast": isLast && containerType === proposalHeroTypes.rectangle.label }, color ?? proposalHeroColorTypes.orange)}></div>
      <div className={classNames("ProposalHeroCircleSquare z-0 relative overflow-hidden ", borderRadius[containerType], containerType, { "isLast": isLast && containerType === proposalHeroTypes.rectangle.label })} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick}>
        <img className="z-0 h-full w-full  bg-no-repeat bg-cover" style={{ backgroundImage: `url(${backgroundImage?.url})`, }} />
        <div className={classNames("ProposalHeroCircleSquareGradientOverlay absolute top-0 left-0 z-1 h-full w-full", containerType, borderRadius[containerType], color ?? proposalHeroColorTypes.orange)}></div>
        <div className="ProposalHeroCircleSquareOverlay absolute top-0 left-0 z-2 h-full w-full "></div>
        <p className="ProposalHeroCircleSquareContent absolute z-2 top-50 left-50 p-3 text-white text-center uppercase">
          {headingText}
        </p>
        {
          isHover && id === currentCard &&
          <i className="ProposalHeroCircleSquareContentIcon absolute z-2 top-50 left-50">{typeIconMap[type]}</i>
        }
      </div>
    </div>
  )
}

export default ProposalHeroCircleSquare






































//outer layer to hold everything ✅
// one image layer - behind everything ✅
// one layer holding the colorful gradient with the white band ✅
// one layer that holds the text,icon and the black gradient ✅

// one last layer for piche wala ghumi ghumi ✅

